module.exports = __webpack_public_path__ + "img/hramW.c168473d.png";